import React from "react";

const StyleContext = React.createContext(null);


export default StyleContext;
